import React, {FC} from 'react';
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import {sx} from './sx'
import DoubleArrowLeftIcon from "@resource/svg/DoubleArrowLeftIcon";
import TuneIcon from '@mui/icons-material/Tune';
import Paper from '@mui/material/Paper';
import {useMedia} from "@hooks/ui/useMedia";
import {FLOATING_SIDEBAR_TOGGLE_CLASS} from "@ui/sidebarPanel/sx";

interface IProps {
    onHideSidebar: () => void
    mobileVariant?: 'arrow' | 'fab'
    floating?: boolean
}

const HideMode: FC<IProps> = ({onHideSidebar, mobileVariant = 'arrow', floating}) => {
    const {isDesktop} = useMedia()

    if (floating) {
        return (
            <IconButtonCustom
                onClick={onHideSidebar}
                sx={sx.floatingBtn}
                className={FLOATING_SIDEBAR_TOGGLE_CLASS}
            >
                <TuneIcon/>
            </IconButtonCustom>
        )
    }

    if (!isDesktop && mobileVariant === 'fab') {
        return (
            <IconButtonCustom
                onClick={onHideSidebar}
                sx={sx.mobileBtn}
            >
                <TuneIcon/>
            </IconButtonCustom>
        )
    }

    return (
        <Paper
            sx={sx.root}
        >
            <IconButtonCustom
                onClick={onHideSidebar}
                color={'#F5F3F0'}
            >
                <DoubleArrowLeftIcon sx={sx.icon}/>
            </IconButtonCustom>
        </Paper>
    );
};

export default HideMode;
